<template>
    <b-modal ref="mdlEditSpesaExtra" id="mdlEditSpesaExtra" :title="modalMode === 'edit' ? (isNew ? 'Nuova Spesa Extra' : 'Aggiorna Spesa Extra') : 'Concludi Spesa Extra'" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <b-row v-if="modalMode === 'edit'">
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Spesa Extra</label>
                <b-form-select v-model="jsonDataSpesaExtra.idSpeseExtra" :options="spesaExtraOptions" value-field="id" text-field="descrizione" @change="onChangeSpesaExtra" required :disabled="isReadOnly || jsonDataSpesaExtra.statoAttuale === 'CONCLUSO' || jsonDataSpesaExtra.statoAttuale === 'IN ATTESA'">
                    <template #first>
                        <b-form-select-option :value="null" disabled>- Seleziona Spesa Extra -</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Data inizio*</label>
                <date-picker v-model="jsonDataSpesaExtra.dataOraInizio" value-type="timestamp" format="DD/MM/YYYY" required :disabled="isReadOnly"></date-picker>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Importo totale*</label>

                <b-form-input v-model="jsonDataSpesaExtra.importo" type="number" step="0.01" :readonly="(spesaSelezionata && !spesaSelezionata.importoLibero) || isReadOnly || jsonDataSpesaExtra.statoAttuale === 'CONCLUSO' || jsonDataSpesaExtra.statoAttuale === 'IN ATTESA'"></b-form-input>
                <!-- Da rivedere bene il readonly e la proprietà del importo libero -->
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Quota IVA(%)</label>
                <b-form-input v-model="percentualeIva" required readonly></b-form-input>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Imponibile*</label>

                <b-form-input v-model="jsonDataSpesaExtra.imponibile" readonly required></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Quota IVA(€)</label>
                <b-form-input v-model="quotaIva" readonly></b-form-input>
            </b-col>

            <b-col cols="12">
                <label class="sa-label-data">Dati Fattura</label>
                <b-form-textarea v-model="jsonDataSpesaExtra.datiFattura" :readonly="isReadOnly" max-rows="8" rows="3"></b-form-textarea>
            </b-col>
        </b-row>

        <b-row v-if="modalMode === 'conclude'">
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Spesa Extra</label>
                <b-form-select v-model="jsonDataSpesaExtra.idSpeseExtra" :options="spesaExtraOptions" value-field="id" text-field="descrizione" @change="onChangeSpesaExtra" disabled>
                    <template #first>
                        <b-form-select-option :value="null" disabled>- Seleziona Spesa Extra -</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Data Fine*</label>
                <date-picker v-model="jsonDataSpesaExtra.dataOraFine" value-type="timestamp" format="DD/MM/YYYY" required @change="calcolaImportoRicorsivo"></date-picker>
            </b-col>
        </b-row>

        <template #modal-footer>
            <b-button size="md" variant="outline-danger" @click="onClickCloseModal">Annulla</b-button>
            <b-button size="md" variant="outline-success" @click="onClickSaveSpesaExtra()">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";

export default {
    mounted() {
        let me = this;
        me.loadSpeseExtra();
    },

    props: {
        idAccettazione: { type: String },
        jsonDataAccettazione: { type: Object },
    },
    components: { DatePicker, ModalError },
    mixins: [UtilityMixin],
    data() {
        return {
            isNew: true,
            pathResource: "/rsaspeseextrapazienti",
            pathResourceSpesaExtra: "/rsaspeseextra",
            spesaExtraOptions: [],
            spesaSelezionata: null,
            quotaIva: 0,
            isReadOnly: false,
            modalMode: "edit",
            jsonDataSpesaExtra: {
                id: null,
                idAccettazione: null,
                idSpeseExtra: null,
                idFattura: null,
                dataOraInizio: null,
                dataOraFine: null,
                spesaExtra: null,
                importo: 0,
                importoFattura: 0,
                aliquotaIva: 0,
                descrizioneIva: null,
                codiceIva: null,
                imponibile: 0,
                totale: 0,
                datiFattura: null,
                statoAttuale: "INSERITO",
                statoAttualeDataOra: new Date(),
            },
        };
    },
    computed: {
        percentualeIva() {
            return this.jsonDataSpesaExtra.aliquotaIva * 100 + "%";
        },
    },
    watch: {
        "jsonDataSpesaExtra.importo": {
            handler: "calcolaTotali",
            immediate: true,
        },
        "jsonDataSpesaExtra.aliquotaIva": {
            handler: "calcolaTotali",
            immediate: true,
        },
    },

    methods: {
        loadSpeseExtra() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSpesaExtra, null, me.loadSpeseExtraSuccess, me.loadSpeseExtraError);
        },

        loadSpeseExtraSuccess(response) {
            let me = this;
            me.spesaExtraOptions = response.data.data.list;
        },
        loadSpeseExtraError(error) {
            let me = this;
            console.error("Errore caricamento spese extra:", error);
            me.$bvToast.toast("Errore nel caricamento delle spese extra", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        onChangeSpesaExtra(idSpesaExtra) {
            let me = this;
            me.selectedSpesaExtra = me.spesaExtraOptions.find((s) => s.id === idSpesaExtra);
            if (me.selectedSpesaExtra) {
                /* && !me.selectedSpesaExtra.importoLibero */
                me.jsonDataSpesaExtra.aliquotaIva = me.selectedSpesaExtra.aliquotaIva;
                me.jsonDataSpesaExtra.importo = me.selectedSpesaExtra.importo;
                me.jsonDataSpesaExtra.descrizioneIva = me.selectedSpesaExtra.descrizioneIva;
                me.jsonDataSpesaExtra.codiceIva = me.selectedSpesaExtra.codiceIva;
                me.jsonDataSpesaExtra.spesaExtra = me.selectedSpesaExtra.descrizione;
            }
            /* console.log("ALIQUOTA IVA:", me.jsonDataSpesaExtra.aliquotaIva);
            console.log("PERCENTUALE IVA:", this.percentualeIva); */
        },
        calcolaTotali() {
            let me = this;
            const importoTotale = me.jsonDataSpesaExtra.importo;
            me.quotaIva = (importoTotale * me.jsonDataSpesaExtra.aliquotaIva).toFixed(2);
            me.jsonDataSpesaExtra.imponibile = (importoTotale - me.quotaIva).toFixed(2);
            /*  me.quotaIva = parseFloat((importoTotale * me.jsonDataSpesaExtra.aliquotaIva).toFixed(2));
                me.jsonDataSpesaExtra.imponibile = parseFloat((importoTotale - me.quotaIva).toFixed(2)); */
        },

        aggiornaSpesaExtraPaziente(item) {
            let me = this;
            if (me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO") {
                me.isReadOnly = true;
                /* me.$bvModal.msgBoxOk("Non è possibile questa operazione su un paziente dimesso", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });

                return; */
            }
            me.modalMode = "edit";
            me.isNew = false;
            me.selectedSpesaExtra = this.spesaExtraOptions.find((s) => s.id === item.idSpeseExtra);
            me.jsonDataSpesaExtra = { ...item };
            me.$refs.mdlEditSpesaExtra.show();
        },

        nuovaSpesaExtraPaziente(idAccettazione) {
            let me = this;
            me.modalMode = "edit";
            me.isNew = true;
            if (me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO") {
                me.$bvModal.msgBoxOk("Non è possibile questa operazione su un paziente dimesso", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            } else
                me.jsonDataSpesaExtra = {
                    idAccettazione: idAccettazione,
                    idSpeseExtra: null,
                    spesaExtra: null,
                    dataOraInizio: null /* .toISOString().split("T")[0] */,
                    importo: 0,
                    aliquotaIva: 0,
                    descrizioneIva: null,
                    codiceIva: null,
                    imponibile: 0,
                    totale: 0,
                    datiFattura: null,
                    statoAttuale: "INSERITO",
                    statoAttualeDataOra: new Date(),
                };
            me.$refs.mdlEditSpesaExtra.show();
        },

        concludiSpesaExtraPaziente(item) {
            let me = this;
            me.isNew = false;
            me.modalMode = "conclude";

            me.jsonDataSpesaExtra = {
                ...item,
            };

            me.$refs.mdlEditSpesaExtra.show();
        },

        // show(jsonData) {
        //     let me = this;
        //     me.jsonDataSpesaExtra = jsonData;
        //     me.title = !me.jsonDataSpesaExtra.id ? "Nuova spesa extra" : "Aggiorna spesa extra";
        //     if (me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO") {
        //         me.$bvModal.msgBoxOk("Non è possibile questa operazione su un paziente dimesso", {
        //             title: "ATTENZIONE",
        //             size: "sm",
        //             okVariant: "outline-danger",
        //             headerClass: "sa-msg-header-danger",
        //             footerClass: "p-2 border-top-0",
        //             centered: true,
        //         });
        //         return;
        //     }
        //     me.loadSpeseExtra();
        //     me.$refs.mdlEditSpesaExtra.show();
        // },

        onClickCloseModal() {
            let me = this;
            me.jsonDataSpesaExtra = {};
            me.$refs.mdlEditSpesaExtra.hide();
            me.$emit("closeModal");
        },

        onClickSaveSpesaExtra() {
            let me = this;
            if (me.modalMode === "conclude") {
                //Controllo sulle date.
                if (new Date(me.jsonDataSpesaExtra.dataOraFine) < new Date(me.jsonDataSpesaExtra.dataOraInizio)) {
                    me.$bvModal.msgBoxOk("La data di fine deve essere successiva alla data di inizio", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    });
                    return;
                }
                me.jsonDataSpesaExtra.statoAttuale = "IN ATTESA";
                me.jsonDataSpesaExtra.statoAttualeDataOra = new Date();
            }
            if (!me.isSpesaRicorsiva(me.jsonDataSpesaExtra.idSpeseExtra)) {
                me.jsonDataSpesaExtra.totale = me.jsonDataSpesaExtra.importo;
            } else {
                me.calcolaImportoRicorsivo();
            }
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataSpesaExtra, me.saveSuccessResponse, me.saveErrorResponse);
        },

        saveSuccessResponse(response) {
            let me = this;
            me.$emit("onSave", response);
            me.$refs.mdlEditSpesaExtra.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onDeleteSpesaExtra(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Spesa Extra",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteSpesaExtra(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteSpesaExtra(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteSpesaExtraSuccess, me.deleteSpesaExtraError);
        },
        deleteSpesaExtraSuccess(response) {
            let me = this;
            me.$emit("deleteSpesaExtra", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteSpesaExtraError(error) {
            let me = this;
            me.$emit("deleteSpesaExtra", error);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        isSpesaRicorsiva(idSpeseExtra) {
            let me = this;
            let speseExtra = me.spesaExtraOptions.find((s) => s.id === idSpeseExtra);
            return speseExtra.spesaRicorsiva === true;
        },

        calcolaImportoRicorsivo() {
            let me = this;
            if (me.jsonDataSpesaExtra.dataOraInizio && me.jsonDataSpesaExtra.dataOraFine) {
                let dataInizio = new Date(me.jsonDataSpesaExtra.dataOraInizio);
                // console.log("DataInizio", dataInizio);
                let dataFine = new Date(me.jsonDataSpesaExtra.dataOraFine);
                // console.log("DataFine", dataFine);

                let diffDate = Math.abs(dataFine - dataInizio);
                // console.log("Differenza date in ms", diffDate);

                let diffGiorni = Math.ceil(diffDate / (1000 * 60 * 60 * 24)) + 1;
                // console.log("Differenza di giorni: ", diffGiorni);

                let importoTotale = me.jsonDataSpesaExtra.importo * diffGiorni;
                me.jsonDataSpesaExtra.totale = importoTotale.toFixed(2);

                return;
            }

            return 0;
        },
    },
};
</script>
